import { Instagram, Facebook, Youtube, Globe } from "lucide-react";
import { BRAND } from "../../data/content";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-ov-navy text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="lg:col-span-6">
            <img src={BRAND.logo} alt="One Vision" className="h-14 w-auto bg-white rounded-xl p-2" />
            <p className="font-display text-2xl md:text-3xl text-white/90 mt-8 max-w-md leading-snug">
              Your property. <span className="text-ov-greenBright">Our responsibility.</span>
            </p>
            <p className="font-body text-white/50 mt-4 max-w-md">
              Compliance today, peace of mind forever.
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-body text-xs uppercase tracking-[0.2em] text-white/40 mb-6">Connect</h4>
            <ul className="space-y-4">
              <li>
                <a href={BRAND.whatsappUrl} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="font-body text-white/80 hover:text-ov-greenBright transition-colors">
                  WhatsApp · +91 {BRAND.whatsapp}
                </a>
              </li>
              <li>
                <a href={BRAND.websiteUrl} target="_blank" rel="noreferrer" data-testid="footer-website" className="inline-flex items-center gap-2 font-body text-white/80 hover:text-ov-greenBright transition-colors">
                  <Globe size={16} /> {BRAND.website}
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-body text-xs uppercase tracking-[0.2em] text-white/40 mb-6">Follow</h4>
            <div className="flex gap-4">
              <a href={BRAND.instagramUrl} target="_blank" rel="noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center hover:bg-ov-green hover:border-ov-green transition-colors">
                <Instagram size={18} />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center hover:bg-ov-green hover:border-ov-green transition-colors">
                <Facebook size={18} />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" data-testid="footer-youtube" aria-label="YouTube" className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center hover:bg-ov-green hover:border-ov-green transition-colors">
                <Youtube size={18} />
              </a>
            </div>
            <p className="font-body text-sm text-white/40 mt-6">@{BRAND.instagram}</p>
          </div>
        </div>

        {/* Giant wordmark */}
        <div className="py-12 overflow-hidden">
          <h2 className="font-display text-[16vw] lg:text-[13vw] leading-none tracking-tighter text-white/5 select-none">
            ONE VISION
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-white/40 text-sm font-body">
          <p>© {new Date().getFullYear()} One Vision. Safe Assets, Safe Nature.</p>
          <p>Founder — Er. Dhamodhar Molugu, B.Tech (Civil)</p>
        </div>
      </div>
    </footer>
  );
}
